import GithubIcon from 'assets/icons/github.svg';
import { IconLink } from './styles';
import LinkedInIcon from 'assets/icons/linkedin.svg';
import MailIcon from 'assets/icons/mail.svg';
import PhoneIcon from 'assets/icons/phone.svg';
import { SocialProps } from './types';

export const Social = ({
  className = '',
  color = 'var(--secondary_500)',
  link,
  type = 'github',
}: SocialProps) => {
  const renderIcon = () => {
    switch (type) {
      case 'linkedin':
        return <LinkedInIcon />;
      case 'github':
        return <GithubIcon />;
      case 'mail':
        return <MailIcon />;
      case 'virtualChat':
        return <PhoneIcon />;
      default:
        return <GithubIcon />;
    }
  };

  return (
    <IconLink
      aria-label={type}
      className={className}
      color={color}
      href={link}
      target='_blank'
    >
      {renderIcon()}
    </IconLink>
  );
};
